module.exports = "/assets/data/8fb5ccde1dd206c6ff52816f32500a33-SN5.data.json";